<template>
  <span>
    <el-tooltip placement="top-start" :content="content">
      <i class="iconfont yx-color-text-regular icon-a-help-circle-obangzhu-xian mr-2"></i>
    </el-tooltip>
    <slot></slot>
  </span>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    content: {
      type: String,
      default: '',
    },
  },
  components: {},

  mounted() { },

  methods: {},
};
</script>
<style lang="less" scoped>
.tip ::before {
  content: '*';
}
</style>
